export default __webpack_public_path__ + "static/media/README.e17cd21b.md";